import { apiOperacionesGETById, Operacion, EnumOperationState } from '../api';
import { operacionArrayFromApi } from '../pages/allocations/allocation.mapper';
import { enumValueToKey } from '../helpers';

export const checkOperationsState = async (
  operationIds: any,
  desiredStates: EnumOperationState[]
): Promise<any> => {
  return await apiOperacionesGETById(operationIds).then(response => {
    let updatedOperations: Operacion[] = [];
    response.forEach(op => {
      if (desiredStates.some(x => x === enumValueToKey(EnumOperationState, op.estadoOperacion))) {
        updatedOperations.push(op);
      }
    });
    return operacionArrayFromApi(updatedOperations);
  });
};
